export type FromType = 'no_shifts' | 'new_shift'

export const FROM = {
  NO_SHIFTS: 'no_shifts',
  NEW_SHIFT: 'new_shift',
} as const
